import type { PurchaseSummary } from '@src/common/types/purchaseSummary';
import {
  getSaleItems,
  getSaleTotalCurrencyInfo,
  getSaleServiceFeeCurrencyInfo,
  getSaleServiceFeeDescriptions,
  getSaleCoupon,
  type Sale,
} from '@src/domains/sales';

export const toPurchaseSummary = (sale: Sale | null | undefined): PurchaseSummary => ({
  items: getSaleItems(sale),
  totalAmountCents: getSaleTotalCurrencyInfo(sale)?.amountCents ?? 0,
  serviceFeeCurrencyInfo: getSaleServiceFeeCurrencyInfo(sale),
  serviceFeeDescriptions: getSaleServiceFeeDescriptions(sale),
  coupon: getSaleCoupon(sale),
});
